import React, { useState } from 'react';
import { X } from 'lucide-react';
import { supabase, isSupabaseConfigured } from '../../config/supabase';

function AddTestimonialModal({ isOpen, onClose }) {
    const [formData, setFormData] = useState({ name: '', role: '', text: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        if (isSupabaseConfigured) {
            try {
                const { error } = await supabase.from('testimonials').insert([formData]);
                if (error) throw error;
            } catch (err) {
                const existing = JSON.parse(localStorage.getItem('ezems_local_testimonials') || '[]');
                localStorage.setItem('ezems_local_testimonials', JSON.stringify([...existing, formData]));
            }
        } else {
            const existing = JSON.parse(localStorage.getItem('ezems_local_testimonials') || '[]');
            localStorage.setItem('ezems_local_testimonials', JSON.stringify([...existing, formData]));
        }
        
        setFormData({ name: '', role: '', text: '' });
        setIsSubmitting(false);
        onClose();
    };

    return (
        <div className="fixed inset-0 z-[110] flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm modal-overlay" onClick={onClose}></div>
            
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md relative z-10 p-6 modal-content">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-bold">Write a Review</h3>
                    <button onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-xs font-bold text-slate-500 mb-1">Name</label>
                        <input 
                            required 
                            className="w-full px-3 py-2 border rounded-lg text-sm text-slate-900 mb-1" 
                            value={formData.name} 
                            onChange={e => setFormData({...formData, name: e.target.value})} 
                            placeholder="Your Name" 
                        />
                    </div>
                    
                    <div>
                        <label className="block text-xs font-bold text-slate-500 mb-1">Role / Company</label>
                        <input 
                            required 
                            className="w-full px-3 py-2 border rounded-lg text-sm text-slate-900 mb-1" 
                            value={formData.role} 
                            onChange={e => setFormData({...formData, role: e.target.value})} 
                            placeholder="CEO, MyCompany" 
                        />
                    </div>
                    
                    <div>
                        <label className="block text-xs font-bold text-slate-500 mb-1">Feedback</label>
                        <textarea 
                            required 
                            rows="3" 
                            className="w-full px-3 py-2 border rounded-lg text-sm text-slate-900 mb-1" 
                            value={formData.text} 
                            onChange={e => setFormData({...formData, text: e.target.value})} 
                            placeholder="How was your experience?"
                        ></textarea>
                    </div>
                    
                    <button 
                        type="submit" 
                        disabled={isSubmitting} 
                        className="w-full py-3 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-colors"
                    >
                        {isSubmitting ? "Submitting..." : "Post Review"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddTestimonialModal;